import { AxiosInstance } from 'axios';
import { generateNotification } from 'shared';
import { NotificationType } from 'shared/src/notification/notification.types';
import i18n from '../../i18n/i18n';

/**
 * API method to trigger the script based database import on the backend
 *
 * @param axios The axios instance
 * @returns Promise of true in case of success, false otherwise
 */
export const triggerDbImport = async (axios: AxiosInstance): Promise<boolean> => {
  return await axios
    .get('/import/proddump')
    .then(() => {
      generateNotification({
        type: NotificationType.SUCCESS,
        value: i18n.t('general.notification.succes.prodImport'),
      });
      return true;
    })
    .catch((exc) => {
      generateNotification({
        type: NotificationType.SUCCESS,
        value: i18n.t('general.notification.error.prodImport'),
      });
      console.error('Error during prod database import!', exc);
      return false;
    });
};
